import { createContext} from "react";

export const OrganizationContext = createContext<string | null>(null)
